'use client'

import dynamic from 'next/dynamic'

// MUST be client-side only - Shadow DOM doesn't work with SSR
const V0ShadowHost = dynamic(
  () => import('@/components/V0ShadowHost'),
  { 
    ssr: false,
    loading: () => (
      <div className="flex items-center justify-center h-[600px] my-8">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4" />
          <p className="text-gray-600">Preparing architecture builder...</p>
        </div>
      </div>
    )
  }
)

interface ProductArchitectureV2ShadowProps {
  enableDynamicNavTracking?: boolean
  compactSpacing?: boolean
}

export function ProductArchitectureV2Shadow({ 
  enableDynamicNavTracking = false,
  compactSpacing = false
}: ProductArchitectureV2ShadowProps) {
  return <V0ShadowHost enableDynamicNavTracking={enableDynamicNavTracking} compactSpacing={compactSpacing} />
}

export default ProductArchitectureV2Shadow